var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center p-1",attrs:{"id":"time-answer"}},[_c('b-time',{attrs:{"locale":"en"},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }